export const SKIP_INTERCEPTOR = 'X-Skip-Interceptor';
